import { JobTitle } from '../types';

export const jobTitleExists = (jobTitles: JobTitle[], jobTitle: string) => {
  const formattedJobTitle = jobTitle.toLowerCase();
  return !jobTitles.some(
    ({ jobTitle: title }) => title.toLowerCase() === formattedJobTitle
  );
};
